// Umrlica.js
import React from "react";
import { Container, Row } from "react-bootstrap";

function Reklama() {
  return (
    <Container
      data-aos="fade-up"
      style={{
        border: "8px groove black",
        backgroundColor: "white",
        maxHeight: "670px",
        height: "100vh",
        marginTop: "20px",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontSize: "25px",
        fontWeight: "bold",
        textAlign: "center",
      }}
    >
      REKLAMA
      <br></br>
      067/068-069
    </Container>
  );
}

export default Reklama;
